import { Injectable } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { AppSettings } from '../../entities/AppSettings';
import { appSettings } from '../../modules/shared/components/appSettings';
import { IDataEndPoint } from '@framework/interfaces/IEntity';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { FileSaverService } from 'ngx-filesaver';

export interface IApiServiceCommand {
  endPoint: IDataEndPoint;
  data?: any;
  context?: any;
  params?: object;
  success?: Function;
  error?: Function;
}
export interface IApiServiceHttpOptions {
  body?: any;
  headers?: HttpHeaders | {
    [header: string]: string | string[];
  };
  params?: HttpParams | {
    [param: string]: string | string[];
  };
  responseType?: 'arraybuffer' | 'blob' | 'json' | 'text';
  reportProgress?: boolean;
  withCredentials?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private heroesUrl = appSettings.apiServiceAddress + '/api/user';
  public appSettings = appSettings;
  public authService: IdentityAuthService
  constructor(
    private http: HttpClient,
    private _FileSaverService: FileSaverService) { }

  async exec<T>(serviceCommand: IApiServiceCommand, currentRequest?: Subscription): Promise<Subscription> {
    let self: ApiService = this;
    let observable: Observable<any>
    let method: string = serviceCommand.endPoint.method ? serviceCommand.endPoint.method.toLowerCase() : "get";


    let url: string = {}.toString.call(serviceCommand.endPoint.url) === '[object Function]' ? serviceCommand.endPoint.url(serviceCommand, self) : serviceCommand.endPoint.url;
    if (!url) return
    /*
    let options: IApiServiceHttpOptions = {};
    if (serviceCommand.endPoint.params) options.params = new HttpParams({ fromObject: serviceCommand.endPoint.params(serviceCommand) });
    if (method == "post") options.body = serviceCommand.data;
    observable = this.http.request<T>(method, url, {
      body: serviceCommand.data ? serviceCommand.data : null,
      params: serviceCommand.endPoint.params ? new HttpParams({ fromObject: serviceCommand.endPoint.params(serviceCommand) }) : null
    });
    */
    await this.authService.ensureAppSettingsLoaded();
    let httpParams: HttpParams;
    if (serviceCommand.endPoint.params) httpParams = new HttpParams({ fromObject: serviceCommand.endPoint.params(serviceCommand) });
    let httpHeaders: HttpHeaders = new HttpHeaders({ "organisation-context": this.authService.currentOrganisationId, "project": this.authService.currentProjectId });
    httpHeaders.append("Authorization", "Bearer " + this.authService.access_token);
    if (method == "post") {
      observable = this.post<T>(url, serviceCommand.data, { params: httpParams, headers: httpHeaders }, serviceCommand.endPoint.serviceAddressIncludedInUrl ? '' : null);
    }
    else {
      observable = this.get<T>(url, { params: httpParams, headers: httpHeaders }, serviceCommand.endPoint.serviceAddressIncludedInUrl ? '' : null);
    }

    if (serviceCommand.success || serviceCommand.error) {
      if (currentRequest && currentRequest.unsubscribe)
        currentRequest.unsubscribe();
      currentRequest =
        observable.subscribe(
          data => { if (serviceCommand.success) serviceCommand.success(data) },
          error => { if (serviceCommand.error) serviceCommand.error(error) }
        )
    }
    return currentRequest;
  }
  get<T>(url: string, params?: any, serviceAddress?: string): Observable<any> {
    let httpHeaders: HttpHeaders = new HttpHeaders({ "organisation-context": this.authService.currentOrganisationId, "project": this.authService.currentProjectId });
    httpHeaders.append("Authorization", "Bearer " + this.authService.access_token);
    if (!params) params = {};
    params.headers = httpHeaders;
    if (serviceAddress == null)
      serviceAddress = appSettings.apiServiceAddress;
    return this.http.get<T>(serviceAddress + url, params);
    //.pipe(
    //  tap(heroes => this.log(`fetched list`)),
    //catchError(this.handleError('getList', []))
    //);
  }
  post<T>(url: string, data?: any, params?: any, serviceAddress?: string): Observable<any> {
    let httpHeaders: HttpHeaders = new HttpHeaders({ "organisation-context": this.authService.currentOrganisationId, "project": this.authService.currentProjectId });
    httpHeaders.append("Authorization", "Bearer " + this.authService.access_token)
    if (!params) params = {};
    params.headers = httpHeaders;
    if (serviceAddress == null)
      serviceAddress = appSettings.apiServiceAddress;
    return this.http.post<T>(serviceAddress + url, data, params);
    //.pipe(
    //  tap(heroes => this.log(`created item`)),
    //catchError(this.handleError('create', []))
    //);
  }

  getItem(id: string): Observable<any> {
    const url = `${this.heroesUrl}/${id}`;
    return this.http.get<any>(url);
    //.pipe(
    //  tap(_ => this.log(`fetched item id=${id}`)),
    //  catchError(this.handleError<any>(`fetched item id=${id}`))
    //);
  }

  private log(message: string) {
    //this.messageService.add('ApiService: ' + message);
  }

  /**
 * Handle Http operation that failed.
 * Let the app continue.
 * @param operation - name of the operation that failed
 * @param result - optional value to return as the observable result
 */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  private getFile(url: string) {
    let headers = new HttpHeaders().append("Authorization", "Bearer " +
      this.authService.access_token)
    return this.http.get(url, { responseType: 'arraybuffer', headers: headers });
  }

  public saveFile(blob, fileName) {
    if (fileName)
      this._FileSaverService.save(blob, fileName);
    else this._FileSaverService.save(blob);
  }

  public downloadFile(endPoint: string) {
    let headers = new HttpHeaders().append("Authorization", "Bearer " +
      this.authService.access_token)
    return this.http.get(endPoint, { responseType: 'arraybuffer', headers: headers });
  }
}


